const TERMS = { upper: 'Folder', lower: 'folder' } as const

export const useFolderTerm = () => {
  return TERMS
}

export type FolderTerm = ReturnType<typeof useFolderTerm>
